import service from '../../index';
export function register(data) {
  return service({
    method: 'POST',
    url: '/api/API/user',
    data: data,
  });
}
export function gologin(data) {
  return service({
    method: 'POST',
    url: '/api/API/user',
    data: data,
  });
}
// 获取列表
export function getindex() {
  return service({
    method: 'get',
    url: '/getindex',
  });
}
// 获取修改的回显内容
export function getEditList(id) {
  return service({
    method: 'get',
    url: '/getEditList',
    params: {
      id: id,
    },
  });
}

export function getUserInfo() {
  return service({
    url: '/api/API/user',
    method: 'get',
    params: {
      action: 'userInfo',
    },
  });
}
